import { useMutation } from '@tanstack/react-query';

import { validateEmailApi } from '../api';

export default function useValidateEmailMutation(config?: any) {
  return useMutation(validateEmailApi, config);
}
